import styled from '@emotion/styled';

export const ErrorPopupOverlay = styled.div`
  height: 100%;
  width: 100%;
  padding: 1rem;
  display: grid;
  align-content: center;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
`;
